<div class="tw-w-full tw-bg-transparent">
  <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-4 tw-bg-gradient-black-to-light-black tw-rounded-t-3xl tw-px-4 tw-pb-7 tw-pt-9 tw-border-t-[3px] tw-border-x-[3px] tw-border-[#c7b189]">
    <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
      <p class="tw-text-[#c7b189] tw-text-[56px] tw-font-bebas tw-leading-none -tw-mb-3">100%</p>
      <span class="tw-text-[#c7b189] tw-inline-block tw-mx-1">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-4 tw-h-4">
          <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
        </svg>
      </span>
      <div class="tw-w-fit tw-flex tw-flex-col tw-justify-center tw-items-start">
        <p class="tw-text-nowrap tw-text-300 tw-text-gray-75 tw-font-medium tw-leading-none" i18n="@@cures">cure's</p>
        <span class="tw-text-gray-50 tw-font-lexend tw-leading-none tw-text-500 tw-font-bold tw-tracking-tighter" i18n="@@moneyBack">MONEY BACK</span>
        <span class="tw-text-[#c7b189] tw-font-lexend tw-leading-none tw-text-500 tw-font-bold -tw-tracking-tight tw-uppercase" i18n="@@guarantee">guarantee</span>
      </div>
    </div>
    <div class="tw-text-gray-50 tw-text-400 tw-w-[8%] tw-font-lexend">
      <svg (click)="closeBottomSheet()" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-w-5 tw-h-5">
        <path d="M6 6 L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M18 6 L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>
  </div>
  <div class="tw-w-full tw-px-6 tw-py-5 tw-pb-8 tw-bg-white">
    <div class="tw-w-full tw-px-2 tw-mb-7">
      <p class="tw-text-400 tw-mb-5 tw-font-body" i18n="@@moneyBackGuaranteeEligibleRefund">If no improvement seen after following the treatment as prescribed, you will be eligible for a <span class="tw-text-[#A78550] tw-font-bold">100% refund.</span></p>
      <p class="tw-text-200 tw-text-gray-600 tw-font-body" i18n="@@moneyBackGuaranteeRefundNote">Note*: Refund applies after following treatment for minimum no of months, as per eligibility criteria.</p>
    </div>
    <span class="tw-w-full tw-bg-teal-600 tw-font-lexend tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-500 tw-flex tw-justify-center tw-items-center tw-font-semibold tw-relative tw-overflow-hidden tw-cursor-pointer" (click)="ctaClick()" i18n="@@viewEligibilityCriteria">
      View Eligibility Criteria
    </span>
  </div>
</div>
